
import React from 'react';
import { useLoading } from './LoadingContext';


const LoadingScreen = () => {
    const { loading } = useLoading();
    if (!loading) return null;
    
    return (
        <div style={styles.overlay}>
            <div style={styles.spinner}></div>
            <div style={styles.text}>Betöltés...</div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(45deg, rgb(60, 60, 60), rgb(34, 34, 34))', // Gradient background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        //animation: 'fadeIn 0.5s ease-in-out',
    },
    spinner: {
        border: '5px solid rgba(255, 255, 255, 0.97)',
        borderTop: '5px solid red', // Tomato red color for the spinner
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        animation: 'spin 1s linear infinite', // Spinning animation
    },
    text: {
        marginTop: '20px',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#fff',
        textTransform: 'uppercase',
        letterSpacing: '2px',
        animation: 'fadeInText 1s ease-in-out', // Text fade-in effect
    },
};

// Spinner animation
const stylesKeyframes = `
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes fadeInText {
    0% { opacity: 0; transform: translateY(20px); }
    100% { opacity: 1; transform: translateY(0); }
}
`;

// Add the keyframes for animations in the style tag of the head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = stylesKeyframes;
document.head.appendChild(styleSheet);

export default LoadingScreen;
